module.exports = __webpack_public_path__ + "img/gusto_1.c65491de.png";